export function getFScaleWindSpeed(fc: number) {
  switch (fc) {
    case 0:
      return "65-85 mph";
    case 1:
      return "86-105 mph";
    case 2:
      return "111-135 mph";
    case 3:
      return "136-165 mph";
    case 4:
      return "166-200 mph";
    case 5:
      return "> 200 mph";
    default:
      return " ";
  }
}
